import { Text } from './index';
import { useIdleTime } from '../../hooks/useIdleTime';

interface IdleTimeDisplayProps {
  lastSeen?: string | Date | null;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  color?: string;
  prefix?: string;
}

/**
 * Displays relative idle time (e.g., "Active now", "Active 5m ago", "Away for 2h")
 * Automatically updates every minute
 */
export function IdleTimeDisplay({
  lastSeen,
  size = 'xs',
  color = 'dimmed',
  prefix = '',
}: IdleTimeDisplayProps) {
  const relativeTime = useIdleTime(lastSeen);

  return (
    <Text size={size} c={color}>
      {prefix}{relativeTime}
    </Text>
  );
}
